module.exports = {"title":"Manage users","user":"User","email":"Email","role":"Role","addNewUser":"Add new user","modalTitle":"Delete user","modalDescription":"Are you sure you want to delete this user","msg":{"yay":"Yay!","oops":"Oops!","success":"User has been updated successfully."},"helps":[{"title":"Tip","content":"<p>Users are individuals who can sell tickets and/or manage your account on your behalf.</p>"}],"video":{"title":"Video Tutorial","content1":"View Client Prefs/Users video"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/Users/ManageUsers/locales/en.json
// module id = 1939
// module chunks = 0